import { provide } from '@servicetitan/react-ioc';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuthHistory } from '../utils/use-auth-history';
import { AuthInvite } from './invite/invite';
import { AuthLogin } from './login/login';
import { AuthRecoveryPassword } from './recovery/recovery-password';
import { AuthRecoveryRequestPassword } from './recovery/recovery-request-password';
import { AuthRegister } from './register/register';

export const AuthModule = provide({ singletons: [] })(() => {
    const history = useAuthHistory();

    return (
        <Routes>
            <Route path={history.map.invite} element={<AuthInvite />} />
            <Route path={history.map.login} element={<AuthLogin />} />
            <Route path={history.map.loginOnInvite} element={<AuthLogin />} />
            <Route path={history.map.register} element={<AuthRegister />} />
            <Route path={history.map.recovery} element={<AuthRecoveryRequestPassword />} />
            <Route path={history.map.recoveryCode} element={<AuthRecoveryPassword />} />
            <Route path="*" element={<Navigate to={history.path('login')} replace />} />
        </Routes>
    );
});
